import type { SlideProps } from "@/engine/app/offsite-config";

const BEISPIELE = [
  {
    title: "Anliegen verstehen",
    text: "Eine KI liest die Kundennachricht, erkennt „IBAN-Änderung + Zählerstand“ und stößt die passenden Vorgänge an.",
  },
  {
    title: "Recherche & Zuarbeit",
    text: "Ein Agent trägt über Nacht Daten aus mehreren Systemen zusammen und legt morgens den Entwurf hin.",
  },
  {
    title: "Ausblick: Telefon",
    text: "Heute sind unsere Telefonansagen KI-generiert — der nächste Schritt ist ein Sprach-Agent, der Anrufe selbst entgegennimmt.",
  },
];

export function Slide10DurchKI(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Arbeiten durch KI</div>
        <h1 className="deck-title rise rise-2">
          Die KI arbeitet <br />
          <span className="accent">selbst — als Agent</span>
        </h1>
        <p className="deck-sub rise rise-3">
          KI-Agenten erledigen Aufgaben eigenständig, Schritt für Schritt — ihr
          merkt oft gar nicht, dass eine KI beteiligt war.
        </p>
      </header>

      <div className="deck-cols2" style={{ gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>
        {BEISPIELE.map((b, i) => (
          <div key={b.title} className={`col-card rise rise-${i + 4}`}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4>{b.title}</h4>
            <p>{b.text}</p>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Jeder Agenten-Schritt wird geloggt — nichts passiert im Verborgenen.</span>
      </footer>
    </div>
  );
}
